import { Environment } from './environment';

// LINE
export const LIFF_ID = process.env.REACT_APP_LIFF_ID as string;

// GA
export const GA_TRACKING_ID = process.env.REACT_APP_GTM_ID;

// API
export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const API_SUCCEEDED = 'succeeded';

// Fluct Tag HTML
export const getHomeFluctNativeAppTagHTML = (): string => {
  // 本番環境の場合、本番用の広告タグを返す
  if (Environment.isProductionStage()) {
    return `
      <div class="gsm-gcm-ad" style="margin: 0 auto; padding: 0; position: relative;">
        <script type="text/javascript" src="https://gcmadv-cdn.goldspotmedia.com/delivery/ad/a7a90a08-ef6e-4f4b-9b11-01ac0a84f50e?gi=gcmInfo_a7a90a08ef6e4f4b9b1101ac0a84f50e" async></script>
        <script type="text/javascript" src="https://gcmast-cdn.goldspotmedia.com/libs/gcm-player/1.10.1/gcm-player.min.js?tg=gcmInfo_a7a90a08ef6e4f4b9b1101ac0a84f50e&tm=gcmMediaInfo_a7a90a08ef6e4f4b9b1101ac0a84f50e" async></script>
      </div>
    `;
  }

  // 開発環境またはステージング環境の場合、開発用の広告タグを返す
  if (Environment.isDevelopmentStage() || Environment.isStagingStage()) {
    return `
      <div class="gsm-gcm-ad" style="margin: 0 auto; padding: 0; position: relative;">
        <script type="text/javascript" src="https://gcmadv-cdn.goldspotmedia.com/delivery/ad/3d46072e-a7e4-42ab-983c-6bd7d07efc40?gi=gcmInfo_3d46072ea7e442ab983c6bd7d07efc40" async></script>
        <script type="text/javascript" src="https://gcmast-cdn.goldspotmedia.com/libs/gcm-player/1.10.1/gcm-player.min.js?tg=gcmInfo_3d46072ea7e442ab983c6bd7d07efc40&tm=gcmMediaInfo_3d46072ea7e442ab983c6bd7d07efc40" async></script>
      </div>
    `;
  }

  // 上記以外の場合（想定外の環境値）は空文字列を返す
  return '';
};

export const HOME_FLUCT_NATIVE_APP_TAG_HTML = getHomeFluctNativeAppTagHTML();
